<div class="app-loader" [class.app-loader--screen]="scope === 'screen'"
  [class.app-loader--on]="show" [attr.aria-hidden]="!show" role="status"
  [attr.data-loader-scope]="scope" [attr.data-loader-active]="active"
  (wheel)="blockScroll($event)" (touchmove)="blockScroll($event)">
  <span class="app-loader__mark" aria-hidden="true"></span>
  <span class="app-loader__sr">Cargando</span>
</div>
